<template>
	<div class="setting-section">
		<div>
			<div class="setting-title">{{ title }}</div>
			<div class="setting-description">
				<slot name="description"> </slot>
			</div>
		</div>
		<div class="pl-3">
			<AppLoader v-if="isLoading" size="20px" />
			<slot v-else name="trigger"> </slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SettingSection',
	components: {},
	props: {
		title: { type: String },
		isLoading: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.setting-section {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
	width: 100%;
}

.setting-title {
	font-size: 16px;
	color: var(--primary-font-color);
}
.setting-description {
	font-size: 12px;
	color: var(--description-text);
}

::v-deep(.swtch) {
	width: 40px;
}
</style>
